






























































import {Component, Vue} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";
import Editor from '@tinymce/tinymce-vue';

class Kk{
  kk_id!:number;
  title!:string;
  description!:string;
  no!:number;
  enabled!:number;
  file!:File;
}

@Component({
    components: {
      ImageUpload,
        Decimal,
        EnabledSwitch,
        DeleteButton,EForm,Number,TextField,Id,Editor
    }
})
export default class KullanimKilavuzu extends  Vue{
    items : Kk[] | null = null;
    dialog = false;
    title:string = "";
    search: string = "";
    baseAction:string = "kk";
    action:string = this.baseAction;
    data : Kk = new Kk();
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "kk_id"
        },
        {text: "Başlık", value: "title"},
        {text: "Sıra", value: "no"},
        {text: "Aktif", value: "enabled"},
        {text: "İşlemler", value: "actions"}
    ];
    edit(item:Kk){
        this.title = "Düzenle";
        this.data = item;
        this.action = this.baseAction + "/" + item.kk_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new Kk();
        this.dialog = true;
    }
    async get(){
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
    }
    created(){
        this.get();
    }
};
